module.exports = __webpack_public_path__ + "img/mark_as_rejected.b388667b.svg";